// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__eGZAG","row":"Option_row__2ITln"};